<div class="flex flex-col gap-2">
  @for (row of rows; track row) {
    <div class="flex flex-col gap-1">
      <div class="flex min-w-0 items-center gap-2">
        <div [class]="getFieldClass(hasError(row))" (click)="search.focus()">
          <app-icon class="!h-4 !w-4 shrink-0 !text-[16px] !leading-none text-slate-400">location_on</app-icon>
          <input
            #search
            appBoardV3PlaceAutocomplete
            type="text"
            autocomplete="off"
            maxlength="1024"
            class="h-full min-w-0 flex-1 !border-0 bg-transparent !p-0 text-sm font-medium text-slate-800 !shadow-none outline-none disabled:cursor-not-allowed"
            [value]="row.text"
            [disabled]="disabled"
            [placeholder]="'address_search_placeholder' | translate"
            [attr.aria-label]="'address' | translate"
            (input)="onTextInput(row, $event)"
            (blur)="onBlur(row)"
            (keydown.enter)="$event.preventDefault()"
            (placeSelected)="onPlaceSelected(row, $event)"
          />
        </div>
        @if (canRemove(row) && !disabled) {
          <button
            type="button"
            class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-slate-400 hover:bg-rose-50 hover:text-rose-600"
            [attr.aria-label]="'delete' | translate"
            (click)="removeRow($index)"
          >
            <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">delete</app-icon>
          </button>
        }
      </div>
      @if (row.address) {
        <div class="grid grid-cols-2 gap-2" [class.pr-11]="canRemove(row) && !disabled">
          <input
            type="text"
            maxlength="255"
            [class]="getInputClass('w-full !px-3')"
            [value]="row.building"
            [disabled]="disabled"
            [placeholder]="'address_building' | translate"
            [attr.aria-label]="'address_building' | translate"
            (input)="onBuildingInput(row, $event)"
            (blur)="onBlur(row)"
          />
          <input
            type="text"
            maxlength="255"
            [class]="getInputClass('w-full !px-3')"
            [value]="row.apartment"
            [disabled]="disabled"
            [placeholder]="'address_apartment' | translate"
            [attr.aria-label]="'address_apartment' | translate"
            (input)="onApartmentInput(row, $event)"
            (blur)="onBlur(row)"
          />
        </div>
      }
      @if (hasError(row)) {
        <p class="m-0 text-xs text-red-500">{{ 'address_select_from_list' | translate }}</p>
      }
    </div>
  }
  @if (!disabled && !(single && rows.length)) {
    <button
      type="button"
      class="flex w-fit items-center gap-1 text-xs font-semibold text-orange-600 hover:text-orange-700"
      (click)="addRow()"
    >
      <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">add</app-icon>
      {{ 'add_address' | translate }}
    </button>
  }
</div>
